import React from 'react';
import { object } from 'prop-types';
import { userModuleTypes } from '../src/utils/misc';
import Users from '../src/components/sections/Users/NewUsers/Users';

const UserSalesChannels = ({ session }) => <Users session={session} type={userModuleTypes[3]} />;

UserSalesChannels.propTypes = {
    session: object
};

export default UserSalesChannels;
